
<template>
  <el-select v-model="value" placeholder="请选择权限类型" @change="setType">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "MuserTypeSelect",
  
  mixins: [BaseVue],
  
  props: {
    muserType: {
      type: String,
      default: ""
    }
  },
  
  data() {
    return {
      options: [
        {
          value: "0",
          label: "人事"
        },
        {
          value: "1",
          label: "人事（可审核）"
        },
        {
          value: "2",
          label: "系统管理员"
        },
        {
          value: "3",
          label: "单位管理员"
        }
      ],
      value: ""  // 权限类型
    };
  },
  
  methods: {
    // event块
    initData(data) {
      this.value = data;
    },
    
    setType(e) {
      // 设置类型逻辑
    }
  },
  
  watch: {
    value(newVal) {
      this.$emit('setType', newVal);
      // 原代码中有注释掉的逻辑，这里保留注释
      // let obj:any = {"0":"人事","1":"人事（可审核）","2":"系统管理员"}
      // let index = this.muserType
      // this.value = obj[index]
    }
  }
};
</script>